import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import LoginModal from "./components/LoginModal/LoginModal";
import ProtectedRoute from "./components/ProtectedRoute";
import DashboardLayout from "./layouts/DashboardLayout";
import UsersPage from "./pages/dashboard/Users/UsersPage";
import GalleryPage from "./pages/dashboard/Gallery/GalleryPage";
import SeoContentPage from "./pages/dashboard/Seo/SeoContentPage";
import Home from "./Home"; // your existing marketing homepage

/* ------------------------------------------------------------------ */
/*  Drop this in as your root App.jsx (or merge the <Routes> block    */
/*  into your existing router). LoginModal is mounted once here so    */
/*  it can be opened from anywhere (e.g. the navbar button in Home)   */
/*  via useAuth().openLoginModal().                                    */
/* ------------------------------------------------------------------ */
export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />

          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="users" replace />} />
            <Route path="users" element={<UsersPage />} />
            <Route path="gallery" element={<GalleryPage />} />
            <Route path="seo" element={<SeoContentPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

        <LoginModal />
      </BrowserRouter>
    </AuthProvider>
  );
}
